import { useEffect } from 'react';

// Screen Wake Lock — keeps the display awake while the component is mounted.
// Re-acquires automatically when the tab/app becomes visible again, since the
// browser releases the lock whenever the page is hidden. Mirrors iOS
// UIApplication.shared.isIdleTimerDisabled on the Orders dashboard and
// driver map.
export function useWakeLock() {
  useEffect(() => {
    if (!('wakeLock' in navigator)) return;
    let sentinel = null;
    let cancelled = false;

    const request = async () => {
      try {
        sentinel = await navigator.wakeLock.request('screen');
      } catch { /* denied, low battery, or unsupported */ }
    };
    const onVisibility = () => {
      if (document.visibilityState === 'visible' && !cancelled) request();
    };

    request();
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      cancelled = true;
      document.removeEventListener('visibilitychange', onVisibility);
      sentinel?.release().catch(() => {});
    };
  }, []);
}
